import { Box } from '@locus-taxy/encore-mui';
import CustomAppEntityHeader from '../components/EntityDetails/CustomAppEntityHeader';
import { MapDetailsContainer } from '../components/EntityDetails/MapDetailsContainer';
import type { EntityDetailsAction } from '../types/actions';

interface MapDetailsPageContainerProps {
  entityName?: string;
  entityId?: string;
  entityNameToShow?: string;
  entityTitle?: string;
  entityData?: Record<string, unknown>;
  actions?: EntityDetailsAction[];
  onActionClick?: (action: EntityDetailsAction) => void;
  onViewSchema?: () => void;
}

export const MapDetailsPageContainer = ({
  entityName = 'map',
  entityId = '',
  entityNameToShow = 'Map Details',
  entityTitle = 'Map',
  entityData = {},
  actions = [],
  onActionClick = () => {},
  onViewSchema,
}: MapDetailsPageContainerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        bgcolor: 'background.paper',
        borderLeft: '1px solid',
        borderColor: 'divider',
      }}
    >
      {/* Header */}
      <CustomAppEntityHeader
        entityName={entityName}
        entityId={entityId}
        entityNameToShow={entityNameToShow}
        entityTitle={entityTitle}
        entityData={entityData}
        actions={actions}
        onActionClick={onActionClick}
        onViewSchema={onViewSchema}
      />

      {/* Content */}
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <MapDetailsContainer
          entityData={entityData}
          mapId={entityId}
          hideBorder
        />
      </Box>
    </Box>
  );
};
